// Anchor Web Systems — content & brand data

export const BRAND = {
  name: "Anchor Web Systems",
  tagline: "Built to Connect. Designed to Perform.",
  email: "hello@anchorwebsystems.com",
  logoMark:
    "https://static.prod-images.emergentagent.com/jobs/0bde0d66-5da7-45ef-b824-cc72c593be3c/images/a0480ed7c126a4c0df3aef82f5827629771784f4d2ea11300b5bd6b17837aba9.png",
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/0bde0d66-5da7-45ef-b824-cc72c593be3c/images/671e7c98da247338890266bb36ee67d2f1bde1438df4df54e3420d30cc0ec72a.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Features", href: "#features" },
  { label: "Platform Preview", href: "#preview" },
  { label: "Industries", href: "#industries" },
  { label: "FAQ", href: "#faq" },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    icon: "PenTool",
    title: "We Build Your Professional Website",
    desc: "Our team designs and launches a fast, modern, mobile-ready website tailored to your local business.",
  },
  {
    step: "02",
    icon: "LayoutDashboard",
    title: "You Receive the Anchor Website Management Platform",
    desc: "Get a simple, friendly platform to manage your content — no code, no confusion, no waiting on anyone.",
  },
  {
    step: "03",
    icon: "ShieldCheck",
    title: "Manage Your Website Anytime",
    desc: "Update services, pricing, photos, hours and content whenever your business changes — on your schedule.",
  },
];

export const FEATURES = [
  { icon: "ListChecks", title: "Services", desc: "Add, edit, or remove the services you offer in just a few clicks." },
  { icon: "Tag", title: "Pricing", desc: "Change your prices anytime and keep customers up to date instantly." },
  { icon: "Images", title: "Photos", desc: "Refresh your galleries and show off your latest work with a click." },
  { icon: "FileText", title: "About Us", desc: "Tell your story and update your message whenever you like." },
  { icon: "Building2", title: "Business Details", desc: "Keep your business information accurate and always current." },
  { icon: "Clock", title: "Business Hours", desc: "Adjust your opening times and holiday hours effortlessly." },
  { icon: "Inbox", title: "Request Service Content", desc: "Control the service-request details your customers see." },
  { icon: "SquarePen", title: "General Website Content", desc: "Edit headlines and page content across your whole site." },
  { icon: "LayoutDashboard", title: "Everything in One Place", desc: "One friendly platform to manage your entire website — no jargon." },
];

export const INDUSTRIES = [
  { name: "Residential Cleaning", icon: "Home" },
  { name: "Commercial Cleaning", icon: "Building" },
  { name: "Janitorial", icon: "SprayCan" },
  { name: "Pressure Washing", icon: "Droplets" },
  { name: "Window Cleaning", icon: "AppWindow" },
  { name: "Landscaping", icon: "Trees" },
  { name: "HVAC", icon: "Wind" },
  { name: "Plumbing", icon: "Wrench" },
  { name: "Electrical", icon: "Zap" },
  { name: "Roofing", icon: "HardHat" },
  { name: "Painting", icon: "Paintbrush" },
  { name: "Handyman", icon: "Hammer" },
  { name: "Pest Control", icon: "Bug" },
  { name: "Pool Services", icon: "Waves" },
  { name: "Auto Detailing", icon: "Car" },
  { name: "Junk Removal", icon: "Trash2" },
  { name: "Property Management", icon: "KeyRound" },
  { name: "Medical Offices", icon: "Stethoscope" },
  { name: "Dental Offices", icon: "Smile" },
  { name: "Restaurants", icon: "UtensilsCrossed" },
  { name: "Retail", icon: "ShoppingBag" },
  { name: "Law Firms", icon: "Scale" },
  { name: "Insurance", icon: "ShieldCheck" },
  { name: "Accounting", icon: "Calculator" },
  { name: "Salons", icon: "Scissors" },
  { name: "Fitness Studios", icon: "Dumbbell" },
  { name: "Professional Services", icon: "Briefcase" },
];

export const WHY_ANCHOR = [
  {
    icon: "Anchor",
    title: "Anchor",
    points: ["Trust", "Reliability", "Strong Foundation"],
    desc: "A dependable partner and a rock-solid platform your business can rely on.",
  },
  {
    icon: "Globe",
    title: "Web",
    points: ["Connection", "Growth", "Online Presence"],
    desc: "Connect with more customers and grow your presence across the web.",
  },
  {
    icon: "Cpu",
    title: "Smart Systems",
    points: ["Technology", "Automation", "Performance"],
    desc: "Smart, automated tools engineered for speed and effortless control.",
  },
];

export const FAQS = [
  {
    q: "What is Anchor Web Systems?",
    a: "Anchor Web Systems is a website management platform for local businesses. We build your professional website, then give you an easy-to-use platform to manage it yourself — so you control your content without depending on a developer.",
  },
  {
    q: "Can I update my own website?",
    a: "Yes. Your website comes with a simple dashboard that lets you edit services, pricing, photos, hours and more — anytime you want, from any device.",
  },
  {
    q: "Do I need coding experience?",
    a: "Not at all. Everything is point-and-click. If you can use email or social media, you can manage your website with Anchor Web Systems.",
  },
  {
    q: "What can I update?",
    a: "Services, pricing, photo galleries, your About Us story, business information, business hours and your service request forms — all from one place.",
  },
  {
    q: "Can I change pricing?",
    a: "Absolutely. Update your prices instantly and your website reflects the changes right away, keeping customers informed.",
  },
  {
    q: "Can I replace photos?",
    a: "Yes. Upload new photos and swap out galleries in seconds to always showcase your best and latest work.",
  },
  {
    q: "Can this work for my business?",
    a: "Very likely. We support dozens of industries — from home services and trades to medical, legal, retail and professional services. If you have a business, we can build for it.",
  },
  {
    q: "How do I request a demo?",
    a: "Fill out the Schedule Your Demo form on this page, or email us at hello@anchorwebsystems.com. We'll show you how the platform works and answer any questions.",
  },
];

export const BUSINESS_TYPES = [
  "Residential Cleaning", "Commercial Cleaning", "Landscaping", "HVAC",
  "Plumbing", "Electrical", "Roofing", "Painting", "Auto Detailing",
  "Medical / Dental", "Restaurant", "Retail", "Professional Services", "Other",
];
